import { Record } from 'immutable';
const defaults = {
  day: 'EVERY_DAY',
  startMinute: 0,
  endMinute: 0
};
export default class AvailableTimeChunk extends Record(defaults) {}